webpackJsonp([114276838955818,60335399758886],{

/***/ 115:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Please Stop","description":"Please Stop - Brisbane's Best Value Band"}}},"layoutContext":{}}

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(224);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(115);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(49);
	var isArguments = __webpack_require__(48);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(462)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('./react-swipe'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.reactSwipe);
	    global.index = mod.exports;
	  }
	})(this, function (exports, _reactSwipe) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  exports.default = _reactSwipe2.default;
	});

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(2), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require('react'), require('prop-types'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.react, global.propTypes);
	    global.reactSwipe = mod.exports;
	  }
	})(this, function (exports, _react, _propTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var supportsCaptureOption = false;
	  function setHasSupportToCaptureOption(hasSupport) {
	    supportsCaptureOption = hasSupport;
	  }
	
	  try {
	    addEventListener("test", null, Object.defineProperty({}, 'capture', { get: function get() {
	        setHasSupportToCaptureOption(true);
	      } }));
	  } catch (e) {}
	
	  function getSafeEventHandlerOpts() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };
	
	    return supportsCaptureOption ? options : options.capture;
	  }
	
	  /**
	   * [getPosition returns a position element that works for mouse or touch events]
	   * @param  {[Event]} event [the received event]
	   * @return {[Object]}      [x and y coords]
	   */
	  function getPosition(event) {
	    if ('touches' in event) {
	      var _event$touches$ = event.touches[0],
	          pageX = _event$touches$.pageX,
	          pageY = _event$touches$.pageY;
	
	      return { x: pageX, y: pageY };
	    }
	
	    var screenX = event.screenX,
	        screenY = event.screenY;
	
	    return { x: screenX, y: screenY };
	  }
	
	  var ReactSwipe = function (_Component) {
	    _inherits(ReactSwipe, _Component);
	
	    function ReactSwipe() {
	      var _ref;
	
	      _classCallCheck(this, ReactSwipe);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));
	
	      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
	      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
	      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);
	
	      _this._onMouseDown = _this._onMouseDown.bind(_this);
	      _this._onMouseMove = _this._onMouseMove.bind(_this);
	      _this._onMouseUp = _this._onMouseUp.bind(_this);
	      return _this;
	    }
	
	    _createClass(ReactSwipe, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.swiper) {
	          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.swiper) {
	          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
	            capture: true,
	            passive: false
	          }));
	        }
	      }
	    }, {
	      key: '_onMouseDown',
	      value: function _onMouseDown(event) {
	        if (!this.props.allowMouseEvents) {
	          return;
	        }
	
	        this.mouseDown = true;
	
	        document.addEventListener('mouseup', this._onMouseUp);
	        document.addEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeStart(event);
	      }
	    }, {
	      key: '_onMouseMove',
	      value: function _onMouseMove(event) {
	        if (!this.mouseDown) {
	          return;
	        }
	
	        this._handleSwipeMove(event);
	      }
	    }, {
	      key: '_onMouseUp',
	      value: function _onMouseUp(event) {
	        this.mouseDown = false;
	
	        document.removeEventListener('mouseup', this._onMouseUp);
	        document.removeEventListener('mousemove', this._onMouseMove);
	
	        this._handleSwipeEnd(event);
	      }
	    }, {
	      key: '_handleSwipeStart',
	      value: function _handleSwipeStart(event) {
	        var _getPosition = getPosition(event),
	            x = _getPosition.x,
	            y = _getPosition.y;
	
	        this.moveStart = { x: x, y: y };
	        this.props.onSwipeStart(event);
	      }
	    }, {
	      key: '_handleSwipeMove',
	      value: function _handleSwipeMove(event) {
	        if (!this.moveStart) {
	          return;
	        }
	
	        var _getPosition2 = getPosition(event),
	            x = _getPosition2.x,
	            y = _getPosition2.y;
	
	        var deltaX = x - this.moveStart.x;
	        var deltaY = y - this.moveStart.y;
	        this.moving = true;
	
	        // handling the responsability of cancelling the scroll to
	        // the component handling the event
	        var shouldPreventDefault = this.props.onSwipeMove({
	          x: deltaX,
	          y: deltaY
	        }, event);
	
	        if (shouldPreventDefault) {
	          event.preventDefault();
	        }
	
	        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
	      }
	    }, {
	      key: '_handleSwipeEnd',
	      value: function _handleSwipeEnd(event) {
	        this.props.onSwipeEnd(event);
	
	        var tolerance = this.props.tolerance;
	
	
	        if (this.moving && this.movePosition) {
	          if (this.movePosition.deltaX < -tolerance) {
	            this.props.onSwipeLeft(1, event);
	          } else if (this.movePosition.deltaX > tolerance) {
	            this.props.onSwipeRight(1, event);
	          }
	          if (this.movePosition.deltaY < -tolerance) {
	            this.props.onSwipeUp(1, event);
	          } else if (this.movePosition.deltaY > tolerance) {
	            this.props.onSwipeDown(1, event);
	          }
	        }
	
	        this.moveStart = null;
	        this.moving = false;
	        this.movePosition = null;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	          this.props.tagName,
	          {
	            ref: function ref(node) {
	              return _this2.swiper = node;
	            },
	            onMouseDown: this._onMouseDown,
	            onTouchStart: this._handleSwipeStart,
	            onTouchEnd: this._handleSwipeEnd,
	            className: this.props.className,
	            style: this.props.style
	          },
	          this.props.children
	        );
	      }
	    }]);
	
	    return ReactSwipe;
	  }(_react.Component);
	
	  ReactSwipe.displayName = 'ReactSwipe';
	  ReactSwipe.propTypes = {
	    tagName: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    children: _propTypes2.default.node,
	    allowMouseEvents: _propTypes2.default.bool,
	    onSwipeUp: _propTypes2.default.func,
	    onSwipeDown: _propTypes2.default.func,
	    onSwipeLeft: _propTypes2.default.func,
	    onSwipeRight: _propTypes2.default.func,
	    onSwipeStart: _propTypes2.default.func,
	    onSwipeMove: _propTypes2.default.func,
	    onSwipeEnd: _propTypes2.default.func,
	    tolerance: _propTypes2.default.number.isRequired
	  };
	  ReactSwipe.defaultProps = {
	    tagName: 'div',
	    allowMouseEvents: false,
	    onSwipeUp: function onSwipeUp() {},
	    onSwipeDown: function onSwipeDown() {},
	    onSwipeLeft: function onSwipeLeft() {},
	    onSwipeRight: function onSwipeRight() {},
	    onSwipeStart: function onSwipeStart() {},
	    onSwipeMove: function onSwipeMove() {},
	    onSwipeEnd: function onSwipeEnd() {},
	
	    tolerance: 0
	  };
	  exports.default = ReactSwipe;
	});

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(59);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(47);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(58);
	
	var _HelmetConstants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (position, axis) {
	    var positionCss = axis === 'horizontal' ? [position, 0, 0] : [0, position, 0];
	    var transitionProp = 'translate3d';
	
	    var translatedPosition = '(' + positionCss.join(',') + ')';
	
	    return transitionProp + translatedPosition;
	};

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssClasses = __webpack_require__(201);
	
	var _cssClasses2 = _interopRequireDefault(_cssClasses);
	
	var _CSSTranslate = __webpack_require__(199);
	
	var _CSSTranslate2 = _interopRequireDefault(_CSSTranslate);
	
	var _reactEasySwipe = __webpack_require__(198);
	
	var _reactEasySwipe2 = _interopRequireDefault(_reactEasySwipe);
	
	var _Thumbs = __webpack_require__(200);
	
	var _Thumbs2 = _interopRequireDefault(_Thumbs);
	
	var _customPropTypes = __webpack_require__(464);
	
	var customPropTypes = _interopRequireWildcard(_customPropTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var noop = function noop() {};
	
	var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
	    return current + ' of ' + total;
	};
	
	var Carousel = function (_Component) {
	    _inherits(Carousel, _Component);
	
	    function Carousel(props) {
	        _classCallCheck(this, Carousel);
	
	        var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));
	
	        _this.setThumbsRef = function (node) {
	            _this.thumbsRef = node;
	        };
	
	        _this.setCarouselWrapperRef = function (node) {
	            _this.carouselWrapperRef = node;
	        };
	
	        _this.setListRef = function (node) {
	            _this.listRef = node;
	        };
	
	        _this.setItemsWrapperRef = function (node) {
	            _this.itemsWrapperRef = node;
	        };
	
	        _this.setItemsRef = function (node, index) {
	            if (!_this.itemsRef) {
	                _this.itemsRef = [];
	            }
	            _this.itemsRef[index] = node;
	        };
	
	        _this.autoPlay = function () {
	            if (!_this.state.autoPlay || _react.Children.count(_this.props.children) <= 1) {
	                return;
	            }
	
	            clearTimeout(_this.timer);
	            _this.timer = setTimeout(function () {
	                _this.increment();
	            }, _this.props.interval);
	        };
	
	        _this.clearAutoPlay = function () {
	            if (!_this.state.autoPlay) {
	                return;
	            }
	
	            clearTimeout(_this.timer);
	        };
	
	        _this.resetAutoPlay = function () {
	            _this.clearAutoPlay();
	            _this.autoPlay();
	        };
	
	        _this.stopOnHover = function () {
	            _this.setState({ isMouseEntered: true });
	            _this.clearAutoPlay();
	        };
	
	        _this.startOnLeave = function () {
	            _this.setState({ isMouseEntered: false });
	            _this.autoPlay();
	        };
	
	        _this.navigateWithKeyboard = function (e) {
	            var axis = _this.props.axis;
	
	            var isHorizontal = axis === 'horizontal';
	            var keyNames = {
	                ArrowUp: 38,
	                ArrowRight: 39,
	                ArrowDown: 40,
	                ArrowLeft: 37
	            };
	
	            var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
	            var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;
	
	            if (nextKey === e.keyCode) {
	                _this.increment();
	            } else if (prevKey === e.keyCode) {
	                _this.decrement();
	            }
	        };
	
	        _this.updateSizes = function () {
	            if (!_this.state.initialized) {
	                return;
	            }
	
	            var isHorizontal = _this.props.axis === 'horizontal';
	            var firstItem = _this.itemsRef[0];
	            var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;
	
	            _this.setState({
	                itemSize: itemSize,
	                wrapperSize: isHorizontal ? itemSize * _react.Children.count(_this.props.children) : itemSize
	            });
	
	            if (_this.thumbsRef) {
	                _this.thumbsRef.updateSizes();
	            }
	        };
	
	        _this.setMountState = function () {
	            _this.setState({ hasMount: true });
	            _this.updateSizes();
	        };
	
	        _this.handleClickItem = function (index, item) {
	            if (_react.Children.count(_this.props.children) <= 1) {
	                return;
	            }
	
	            if (_this.state.cancelClick) {
	                _this.setState({
	                    cancelClick: false
	                });
	
	                return;
	            }
	
	            _this.props.onClickItem(index, item);
	
	            if (index !== _this.state.selectedItem) {
	                _this.setState({
	                    selectedItem: index
	                });
	            }
	        };
	
	        _this.handleOnChange = function (index, item) {
	            if (_react.Children.count(_this.props.children) <= 1) {
	                return;
	            }
	
	            _this.props.onChange(index, item);
	        };
	
	        _this.handleClickThumb = function (index, item) {
	            _this.props.onClickThumb(index, item);
	
	            _this.selectItem({
	                selectedItem: index
	            });
	        };
	
	        _this.onSwipeStart = function () {
	            _this.setState({
	                swiping: true
	            });
	            _this.clearAutoPlay();
	        };
	
	        _this.onSwipeEnd = function () {
	            _this.setState({
	                swiping: false
	            });
	            _this.autoPlay();
	        };
	
	        _this.onSwipeMove = function (delta) {
	            var isHorizontal = _this.props.axis === 'horizontal';
	
	            var initialBoundry = 0;
	
	            var currentPosition = _this.getPosition(_this.state.selectedItem);
	            var finalBoundry = _this.getPosition(_react.Children.count(_this.props.children) - 1);
	
	            var axisDelta = isHorizontal ? delta.x : delta.y;
	            var handledDelta = axisDelta;
	
	            // prevent user from swiping left out of boundaries
	            if (currentPosition === initialBoundry && axisDelta > 0) {
	                handledDelta = 0;
	            }
	
	            // prevent user from swiping right out of boundaries
	            if (currentPosition === finalBoundry && axisDelta < 0) {
	                handledDelta = 0;
	            }
	
	            var position = currentPosition + 100 / (_this.state.itemSize / handledDelta) + '%';
	
	            _this.setPosition(position);
	
	            // allows scroll if the swipe was within the tolerance
	            var hasMoved = Math.abs(axisDelta) > _this.props.swipeScrollTolerance;
	
	            if (hasMoved && !_this.state.cancelClick) {
	                _this.setState({
	                    cancelClick: true
	                });
	            }
	
	            return hasMoved;
	        };
	
	        _this.setPosition = function (position) {
	            var list = _reactDom2.default.findDOMNode(_this.listRef);
	            ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	                list.style[prop] = (0, _CSSTranslate2.default)(position, _this.props.axis);
	            });
	        };
	
	        _this.decrement = function (positions) {
	            _this.moveTo(_this.state.selectedItem - (typeof positions === 'Number' ? positions : 1));
	        };
	
	        _this.increment = function (positions) {
	            _this.moveTo(_this.state.selectedItem + (typeof positions === 'Number' ? positions : 1));
	        };
	
	        _this.moveTo = function (position) {
	            var lastPosition = _react.Children.count(_this.props.children) - 1;
	
	            if (position < 0) {
	                position = _this.props.infiniteLoop ? lastPosition : 0;
	            }
	
	            if (position > lastPosition) {
	                position = _this.props.infiniteLoop ? 0 : lastPosition;
	            }
	
	            _this.selectItem({
	                // if it's not a slider, we don't need to set position here
	                selectedItem: position
	            });
	
	            // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
	            // and will result in the interval function not being cleared correctly.
	            if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
	                _this.resetAutoPlay();
	            }
	        };
	
	        _this.changeItem = function (e) {
	            var newIndex = e.target.value;
	
	            _this.selectItem({
	                selectedItem: newIndex
	            });
	        };
	
	        _this.selectItem = function (state) {
	            _this.setState(state);
	            _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
	        };
	
	        _this.getInitialImage = function () {
	            var selectedItem = _this.props.selectedItem;
	            var item = _this.itemsRef && _this.itemsRef[selectedItem];
	            var images = item && item.getElementsByTagName('img');
	            return images && images[selectedItem];
	        };
	
	        _this.getVariableImageHeight = function (position) {
	            var item = _this.itemsRef && _this.itemsRef[position];
	            var images = item && item.getElementsByTagName('img');
	            if (_this.state.hasMount && images.length > 0) {
	                var image = images[0];
	
	                if (!image.complete) {
	                    // if the image is still loading, the size won't be available so we trigger a new render after it's done
	                    var onImageLoad = function onImageLoad() {
	                        _this.forceUpdate();
	                        image.removeEventListener('load', onImageLoad);
	                    };
	
	                    image.addEventListener('load', onImageLoad);
	                }
	
	                var height = image.clientHeight;
	                return height > 0 ? height : null;
	            }
	
	            return null;
	        };
	
	        _this.state = {
	            initialized: false,
	            selectedItem: props.selectedItem,
	            hasMount: false,
	            isMouseEntered: false,
	            autoPlay: props.autoPlay
	        };
	        return _this;
	    }
	
	    _createClass(Carousel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!this.props.children) {
	                return;
	            }
	
	            this.setupCarousel();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if (nextProps.selectedItem !== this.state.selectedItem) {
	                this.updateSizes();
	                this.moveTo(nextProps.selectedItem);
	            }
	
	            if (nextProps.autoPlay !== this.state.autoPlay) {
	                this.setState({
	                    autoPlay: nextProps.autoPlay
	                }, function () {
	                    if (_this2.state.autoPlay) {
	                        _this2.setupAutoPlay();
	                    } else {
	                        _this2.destroyAutoPlay();
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (!prevProps.children && this.props.children && !this.state.initialized) {
	                this.setupCarousel();
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.destroyCarousel();
	        }
	    }, {
	        key: 'setupCarousel',
	        value: function setupCarousel() {
	            this.bindEvents();
	
	            if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
	                this.setupAutoPlay();
	            }
	
	            this.setState({
	                initialized: true
	            });
	
	            var initialImage = this.getInitialImage();
	            if (initialImage) {
	                // if it's a carousel of images, we set the mount state after the first image is loaded
	                initialImage.addEventListener('load', this.setMountState);
	            } else {
	                this.setMountState();
	            }
	        }
	    }, {
	        key: 'destroyCarousel',
	        value: function destroyCarousel() {
	            if (this.state.initialized) {
	                this.unbindEvents();
	                this.destroyAutoPlay();
	            }
	        }
	    }, {
	        key: 'setupAutoPlay',
	        value: function setupAutoPlay() {
	            this.autoPlay();
	            var carouselWrapper = this.carouselWrapperRef;
	
	            if (this.props.stopOnHover && carouselWrapper) {
	                carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
	                carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
	            }
	        }
	    }, {
	        key: 'destroyAutoPlay',
	        value: function destroyAutoPlay() {
	            this.clearAutoPlay();
	            var carouselWrapper = this.carouselWrapperRef;
	
	            if (this.props.stopOnHover && carouselWrapper) {
	                carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
	                carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
	            }
	        }
	    }, {
	        key: 'bindEvents',
	        value: function bindEvents() {
	            // as the widths are calculated, we need to resize
	            // the carousel when the window is resized
	            window.addEventListener("resize", this.updateSizes);
	            // issue #2 - image loading smaller
	            window.addEventListener("DOMContentLoaded", this.updateSizes);
	
	            if (this.props.useKeyboardArrows) {
	                document.addEventListener("keydown", this.navigateWithKeyboard);
	            }
	        }
	    }, {
	        key: 'unbindEvents',
	        value: function unbindEvents() {
	            // removing listeners
	            window.removeEventListener("resize", this.updateSizes);
	            window.removeEventListener("DOMContentLoaded", this.updateSizes);
	
	            var initialImage = this.getInitialImage();
	            if (initialImage) {
	                initialImage.removeEventListener("load", this.setMountState);
	            }
	
	            if (this.props.useKeyboardArrows) {
	                document.removeEventListener("keydown", this.navigateWithKeyboard);
	            }
	        }
	    }, {
	        key: 'getPosition',
	        value: function getPosition(index) {
	            if (this.props.centerMode && this.props.axis === 'horizontal') {
	                var currentPosition = -index * this.props.centerSlidePercentage;
	                var lastPosition = _react.Children.count(this.props.children) - 1;
	
	                if (index && index !== lastPosition) {
	                    currentPosition += (100 - this.props.centerSlidePercentage) / 2;
	                } else if (index === lastPosition) {
	                    currentPosition += 100 - this.props.centerSlidePercentage;
	                }
	
	                return currentPosition;
	            }
	
	            return -index * 100;
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems() {
	            var _this3 = this;
	
	            return _react.Children.map(this.props.children, function (item, index) {
	                var itemClass = _cssClasses2.default.ITEM(true, index === _this3.state.selectedItem);
	                var slideProps = {
	                    ref: function ref(e) {
	                        return _this3.setItemsRef(e, index);
	                    },
	                    key: 'itemKey' + index,
	                    className: _cssClasses2.default.ITEM(true, index === _this3.state.selectedItem),
	                    onClick: _this3.handleClickItem.bind(_this3, index, item)
	                };
	
	                if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
	                    slideProps.style = {
	                        minWidth: _this3.props.centerSlidePercentage + '%'
	                    };
	                }
	
	                return _react2.default.createElement(
	                    'li',
	                    slideProps,
	                    item
	                );
	            });
	        }
	    }, {
	        key: 'renderControls',
	        value: function renderControls() {
	            var _this4 = this;
	
	            if (!this.props.showIndicators) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'ul',
	                { className: 'control-dots' },
	                _react.Children.map(this.props.children, function (item, index) {
	                    return _react2.default.createElement('li', { className: _cssClasses2.default.DOT(index === _this4.state.selectedItem), onClick: _this4.changeItem, value: index, key: index });
	                })
	            );
	        }
	    }, {
	        key: 'renderStatus',
	        value: function renderStatus() {
	            if (!this.props.showStatus) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                'p',
	                { className: 'carousel-status' },
	                this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children))
	            );
	        }
	    }, {
	        key: 'renderThumbs',
	        value: function renderThumbs() {
	            if (!this.props.showThumbs || _react.Children.count(this.props.children) === 0) {
	                return null;
	            }
	
	            return _react2.default.createElement(
	                _Thumbs2.default,
	                { ref: this.setThumbsRef, onSelectItem: this.handleClickThumb, selectedItem: this.state.selectedItem, transitionTime: this.props.transitionTime, thumbWidth: this.props.thumbWidth },
	                this.props.children
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.children || _react.Children.count(this.props.children) === 0) {
	                return null;
	            }
	
	            var itemsLength = _react.Children.count(this.props.children);
	
	            var isHorizontal = this.props.axis === 'horizontal';
	
	            var canShowArrows = this.props.showArrows && itemsLength > 1;
	
	            // show left arrow?
	            var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop);
	            // show right arrow
	            var hasNext = canShowArrows && (this.state.selectedItem < itemsLength - 1 || this.props.infiniteLoop);
	            // obj to hold the transformations and styles
	            var itemListStyles = {};
	
	            var currentPosition = this.getPosition(this.state.selectedItem);
	
	            // if 3d is available, let's take advantage of the performance of transform
	            var transformProp = (0, _CSSTranslate2.default)(currentPosition + '%', this.props.axis);
	
	            var transitionTime = this.props.transitionTime + 'ms';
	
	            itemListStyles = {
	                'WebkitTransform': transformProp,
	                'MozTransform': transformProp,
	                'MsTransform': transformProp,
	                'OTransform': transformProp,
	                'transform': transformProp,
	                'msTransform': transformProp
	            };
	
	            if (!this.state.swiping) {
	                itemListStyles = _extends({}, itemListStyles, {
	                    'WebkitTransitionDuration': transitionTime,
	                    'MozTransitionDuration': transitionTime,
	                    'MsTransitionDuration': transitionTime,
	                    'OTransitionDuration': transitionTime,
	                    'transitionDuration': transitionTime,
	                    'msTransitionDuration': transitionTime
	                });
	            }
	
	            var swiperProps = {
	                selectedItem: this.state.selectedItem,
	                className: _cssClasses2.default.SLIDER(true, this.state.swiping),
	                onSwipeMove: this.onSwipeMove,
	                onSwipeStart: this.onSwipeStart,
	                onSwipeEnd: this.onSwipeEnd,
	                style: itemListStyles,
	                tolerance: this.props.swipeScrollTolerance
	            };
	
	            var containerStyles = {};
	
	            if (isHorizontal) {
	                swiperProps.onSwipeLeft = this.increment;
	                swiperProps.onSwipeRight = this.decrement;
	
	                if (this.props.dynamicHeight) {
	                    var itemHeight = this.getVariableImageHeight(this.state.selectedItem);
	                    swiperProps.style.height = itemHeight || 'auto';
	                    containerStyles.height = itemHeight || 'auto';
	                }
	            } else {
	                swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.increment : this.decrement;
	                swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.decrement : this.increment;
	                swiperProps.style.height = this.state.itemSize;
	                containerStyles.height = this.state.itemSize;
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: this.props.className, ref: this.setCarouselWrapperRef },
	                _react2.default.createElement(
	                    'div',
	                    { className: _cssClasses2.default.CAROUSEL(true), style: { width: this.props.width } },
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_PREV(!hasPrev), onClick: this.decrement }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _cssClasses2.default.WRAPPER(true, this.props.axis), style: containerStyles, ref: this.setItemsWrapperRef },
	                        this.props.swipeable ? _react2.default.createElement(
	                            _reactEasySwipe2.default,
	                            _extends({
	                                tagName: 'ul',
	                                ref: this.setListRef
	                            }, swiperProps, {
	                                allowMouseEvents: this.props.emulateTouch }),
	                            this.renderItems()
	                        ) : _react2.default.createElement(
	                            'ul',
	                            {
	                                className: _cssClasses2.default.SLIDER(true, this.state.swiping),
	                                style: itemListStyles },
	                            this.renderItems()
	                        )
	                    ),
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_NEXT(!hasNext), onClick: this.increment }),
	                    this.renderControls(),
	                    this.renderStatus()
	                ),
	                this.renderThumbs()
	            );
	        }
	    }]);
	
	    return Carousel;
	}(_react.Component);
	
	Carousel.displayName = 'Carousel';
	Carousel.propTypes = {
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.node,
	    showArrows: _propTypes2.default.bool,
	    showStatus: _propTypes2.default.bool,
	    showIndicators: _propTypes2.default.bool,
	    infiniteLoop: _propTypes2.default.bool,
	    showThumbs: _propTypes2.default.bool,
	    thumbWidth: _propTypes2.default.number,
	    selectedItem: _propTypes2.default.number,
	    onClickItem: _propTypes2.default.func.isRequired,
	    onClickThumb: _propTypes2.default.func.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    axis: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	    verticalSwipe: _propTypes2.default.oneOf(['natural', 'standard']),
	    width: customPropTypes.unit,
	    useKeyboardArrows: _propTypes2.default.bool,
	    autoPlay: _propTypes2.default.bool,
	    stopOnHover: _propTypes2.default.bool,
	    interval: _propTypes2.default.number,
	    transitionTime: _propTypes2.default.number,
	    swipeScrollTolerance: _propTypes2.default.number,
	    swipeable: _propTypes2.default.bool,
	    dynamicHeight: _propTypes2.default.bool,
	    emulateTouch: _propTypes2.default.bool,
	    statusFormatter: _propTypes2.default.func.isRequired,
	    centerMode: _propTypes2.default.bool,
	    centerSlidePercentage: _propTypes2.default.number
	};
	Carousel.defaultProps = {
	    showIndicators: true,
	    showArrows: true,
	    showStatus: true,
	    showThumbs: true,
	    infiniteLoop: false,
	    selectedItem: 0,
	    axis: 'horizontal',
	    verticalSwipe: 'standard',
	    width: '100%',
	    useKeyboardArrows: false,
	    autoPlay: false,
	    stopOnHover: true,
	    interval: 3000,
	    transitionTime: 350,
	    swipeScrollTolerance: 5,
	    swipeable: true,
	    dynamicHeight: false,
	    emulateTouch: false,
	    onClickItem: noop,
	    onClickThumb: noop,
	    onChange: noop,
	    statusFormatter: defaultStatusFormatter,
	    centerMode: false,
	    centerSlidePercentage: 80
	};
	exports.default = Carousel;

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssClasses = __webpack_require__(201);
	
	var _cssClasses2 = _interopRequireDefault(_cssClasses);
	
	var _dimensions = __webpack_require__(465);
	
	var _CSSTranslate = __webpack_require__(199);
	
	var _CSSTranslate2 = _interopRequireDefault(_CSSTranslate);
	
	var _reactEasySwipe = __webpack_require__(198);
	
	var _reactEasySwipe2 = _interopRequireDefault(_reactEasySwipe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Thumbs = function (_Component) {
	    _inherits(Thumbs, _Component);
	
	    function Thumbs(props) {
	        _classCallCheck(this, Thumbs);
	
	        var _this = _possibleConstructorReturn(this, (Thumbs.__proto__ || Object.getPrototypeOf(Thumbs)).call(this, props));
	
	        _this.setItemsWrapperRef = function (node) {
	            _this.itemsWrapperRef = node;
	        };
	
	        _this.setItemsListRef = function (node) {
	            _this.itemsListRef = node;
	        };
	
	        _this.setThumbsRef = function (node, index) {
	            if (!_this.thumbsRef) {
	                _this.thumbsRef = [];
	            }
	            _this.thumbsRef[index] = node;
	        };
	
	        _this.updateSizes = function () {
	            if (!_this.props.children || !_this.itemsWrapperRef) {
	                return;
	            }
	
	            var total = _this.props.children.length;
	            var wrapperSize = _this.itemsWrapperRef.clientWidth;
	            var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
	            var visibleItems = Math.floor(wrapperSize / itemSize);
	            var lastPosition = total - visibleItems;
	            var showArrows = visibleItems < total;
	            _this.setState({
	                itemSize: itemSize,
	                visibleItems: visibleItems,
	                firstItem: showArrows ? _this.getFirstItem(_this.props.selectedItem) : 0,
	                lastPosition: lastPosition,
	                showArrows: showArrows
	            });
	        };
	
	        _this.setMountState = function () {
	            _this.setState({ hasMount: true });
	            _this.updateSizes();
	        };
	
	        _this.handleClickItem = function (index, item) {
	            var handler = _this.props.onSelectItem;
	
	            if (typeof handler === 'function') {
	                handler(index, item);
	            }
	        };
	
	        _this.onSwipeStart = function () {
	            _this.setState({
	                swiping: true
	            });
	        };
	
	        _this.onSwipeEnd = function () {
	            _this.setState({
	                swiping: false
	            });
	        };
	
	        _this.onSwipeMove = function (deltaX) {
	            var leftBoundary = 0;
	
	            var currentPosition = -_this.state.firstItem * _this.state.itemSize;
	            var lastLeftBoundary = -_this.state.visibleItems * _this.state.itemSize;
	
	            // prevent user from swiping left out of boundaries
	            if (currentPosition === leftBoundary && deltaX > 0) {
	                deltaX = 0;
	            }
	
	            // prevent user from swiping right out of boundaries
	            if (currentPosition === lastLeftBoundary && deltaX < 0) {
	                deltaX = 0;
	            }
	
	            var wrapperSize = _this.itemsWrapperRef.clientWidth;
	            var position = currentPosition + 100 / (wrapperSize / deltaX) + '%';
	
	            // if 3d isn't available we will use left to move
	            ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
	                _this.itemsListRef.style[prop] = (0, _CSSTranslate2.default)(position, _this.props.axis);
	            });
	        };
	
	        _this.slideRight = function (positions) {
	            _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
	        };
	
	        _this.slideLeft = function (positions) {
	            _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
	        };
	
	        _this.moveTo = function (position) {
	            // position can't be lower than 0
	            position = position < 0 ? 0 : position;
	            // position can't be higher than last postion
	            position = position >= _this.lastPosition ? _this.lastPosition : position;
	
	            _this.setState({
	                firstItem: position,
	                // if it's not a slider, we don't need to set position here
	                selectedItem: _this.state.selectedItem
	            });
	        };
	
	        _this.state = {
	            selectedItem: props.selectedItem,
	            hasMount: false,
	            firstItem: 0,
	            itemSize: null,
	            visibleItems: 0,
	            lastPosition: 0,
	            showArrows: false,
	            images: _this.getImages()
	        };
	        return _this;
	    }
	
	    _createClass(Thumbs, [{
	        key: 'componentDidMount',
	        value: function componentDidMount(nextProps) {
	            this.setupThumbs();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(props, state) {
	            if (props.selectedItem !== this.state.selectedItem) {
	                this.setState({
	                    selectedItem: props.selectedItem,
	                    firstItem: this.getFirstItem(props.selectedItem)
	                });
	            }
	            if (props.children !== this.props.children) {
	                this.setState({
	                    images: this.getImages()
	                });
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            if (this.props.children === prevProps.children) {
	                return;
	            }
	
	            // This will capture any size changes for arrow adjustments etc.
	            // usually in the same render cycle so we don't see any flickers
	            this.updateSizes();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.destroyThumbs();
	        }
	    }, {
	        key: 'setupThumbs',
	        value: function setupThumbs() {
	            // as the widths are calculated, we need to resize
	            // the carousel when the window is resized
	            window.addEventListener("resize", this.updateSizes);
	            // issue #2 - image loading smaller
	            window.addEventListener("DOMContentLoaded", this.updateSizes);
	
	            // when the component is rendered we need to calculate
	            // the container size to adjust the responsive behaviour
	            this.updateSizes();
	        }
	    }, {
	        key: 'destroyThumbs',
	        value: function destroyThumbs() {
	            // removing listeners
	            window.removeEventListener("resize", this.updateSizes);
	            window.removeEventListener("DOMContentLoaded", this.updateSizes);
	        }
	    }, {
	        key: 'getImages',
	        value: function getImages() {
	            var images = _react.Children.map(this.props.children, function (item, index) {
	                var img = item;
	
	                // if the item is not an image, try to find the first image in the item's children.
	                if (item.type !== "img") {
	                    img = _react.Children.toArray(item.props.children).filter(function (children) {
	                        return children.type === "img";
	                    })[0];
	                }
	
	                if (!img || img.length === 0) {
	                    return null;
	                }
	
	                return img;
	            });
	
	            if (images.filter(function (image) {
	                return image !== null;
	            }).length === 0) {
	                console.warn('No images found! Can\'t build the thumb list without images. If you don\'t need thumbs, set showThumbs={false} in the Carousel. Note that it\'s not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md');
	
	                return null;
	            }
	
	            return images;
	        }
	    }, {
	        key: 'getFirstItem',
	        value: function getFirstItem(selectedItem) {
	            var firstItem = selectedItem;
	
	            if (selectedItem >= this.state.lastPosition) {
	                firstItem = this.state.lastPosition;
	            }
	
	            if (selectedItem < this.state.firstItem + this.state.visibleItems) {
	                firstItem = this.state.firstItem;
	            }
	
	            if (selectedItem < this.state.firstItem) {
	                firstItem = selectedItem;
	            }
	
	            return firstItem;
	        }
	    }, {
	        key: 'renderItems',
	        value: function renderItems() {
	            var _this2 = this;
	
	            return this.state.images.map(function (img, index) {
	                var itemClass = _cssClasses2.default.ITEM(false, index === _this2.state.selectedItem && _this2.state.hasMount);
	
	                var thumbProps = {
	                    key: index,
	                    ref: function ref(e) {
	                        return _this2.setThumbsRef(e, index);
	                    },
	                    className: itemClass,
	                    onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index])
	                };
	
	                if (index === 0) {
	                    img = _react2.default.cloneElement(img, {
	                        onLoad: _this2.setMountState
	                    });
	                }
	
	                return _react2.default.createElement(
	                    'li',
	                    thumbProps,
	                    img
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.props.children) {
	                return null;
	            }
	
	            // show left arrow?
	            var hasPrev = this.state.showArrows && this.state.firstItem > 0;
	            // show right arrow
	            var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition;
	            // obj to hold the transformations and styles
	            var itemListStyles = {};
	
	            var currentPosition = -this.state.firstItem * this.state.itemSize + 'px';
	
	            var transformProp = (0, _CSSTranslate2.default)(currentPosition, this.props.axis);
	
	            var transitionTime = this.props.transitionTime + 'ms';
	
	            itemListStyles = {
	                'WebkitTransform': transformProp,
	                'MozTransform': transformProp,
	                'MsTransform': transformProp,
	                'OTransform': transformProp,
	                'transform': transformProp,
	                'msTransform': transformProp,
	                'WebkitTransitionDuration': transitionTime,
	                'MozTransitionDuration': transitionTime,
	                'MsTransitionDuration': transitionTime,
	                'OTransitionDuration': transitionTime,
	                'transitionDuration': transitionTime,
	                'msTransitionDuration': transitionTime
	            };
	
	            return _react2.default.createElement(
	                'div',
	                { className: _cssClasses2.default.CAROUSEL(false) },
	                _react2.default.createElement(
	                    'div',
	                    { className: _cssClasses2.default.WRAPPER(false), ref: this.setItemsWrapperRef },
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_PREV(!hasPrev), onClick: this.slideRight }),
	                    _react2.default.createElement(
	                        _reactEasySwipe2.default,
	                        { tagName: 'ul',
	                            selectedItem: this.state.selectedItem,
	                            className: _cssClasses2.default.SLIDER(false, this.state.swiping),
	                            onSwipeLeft: this.slideLeft,
	                            onSwipeRight: this.slideRight,
	                            onSwipeMove: this.onSwipeMove,
	                            onSwipeStart: this.onSwipeStart,
	                            onSwipeEnd: this.onSwipeEnd,
	                            style: itemListStyles,
	                            ref: this.setItemsListRef },
	                        this.renderItems()
	                    ),
	                    _react2.default.createElement('button', { type: 'button', className: _cssClasses2.default.ARROW_NEXT(!hasNext), onClick: this.slideLeft })
	                )
	            );
	        }
	    }]);
	
	    return Thumbs;
	}(_react.Component);
	
	Thumbs.displayName = 'Thumbs';
	Thumbs.propsTypes = {
	    children: _propTypes2.default.element.isRequired,
	    transitionTime: _propTypes2.default.number,
	    selectedItem: _propTypes2.default.number,
	    thumbWidth: _propTypes2.default.number
	};
	Thumbs.defaultProps = {
	    selectedItem: 0,
	    transitionTime: 350,
	    axis: 'horizontal'
	};
	exports.default = Thumbs;

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classnames = __webpack_require__(237);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    CAROUSEL: function CAROUSEL(isSlider) {
	        return (0, _classnames2.default)({
	            "carousel": true,
	            "carousel-slider": isSlider
	        });
	    },
	
	    WRAPPER: function WRAPPER(isSlider, axis) {
	        return (0, _classnames2.default)({
	            "thumbs-wrapper": !isSlider,
	            "slider-wrapper": isSlider,
	            "axis-horizontal": axis === "horizontal",
	            "axis-vertical": axis !== "horizontal"
	        });
	    },
	
	    SLIDER: function SLIDER(isSlider, isSwiping) {
	        return (0, _classnames2.default)({
	            "thumbs": !isSlider,
	            "slider": isSlider,
	            "animated": !isSwiping
	        });
	    },
	
	    ITEM: function ITEM(isSlider, selected) {
	        return (0, _classnames2.default)({
	            "thumb": !isSlider,
	            "slide": isSlider,
	            "selected": selected
	        });
	    },
	
	    ARROW_PREV: function ARROW_PREV(disabled) {
	        return (0, _classnames2.default)({
	            "control-arrow control-prev": true,
	            "control-disabled": disabled
	        });
	    },
	
	    ARROW_NEXT: function ARROW_NEXT(disabled) {
	        return (0, _classnames2.default)({
	            "control-arrow control-next": true,
	            "control-disabled": disabled
	        });
	    },
	
	    DOT: function DOT(selected) {
	        return (0, _classnames2.default)({
	            "dot": true,
	            'selected': selected
	        });
	    }
	};

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var unit = exports.unit = function unit(props, propName, componentName) {
	    if (!/(pt|px|em|rem|vw|vh|%)$/.test(props[propName])) {
	        return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Validation failed. It needs to be a size unit like pt, px, em, rem, vw, %');
	    }
	};

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var outerWidth = exports.outerWidth = function outerWidth(el) {
		var width = el.offsetWidth;
		var style = getComputedStyle(el);
	
		width += parseInt(style.marginLeft) + parseInt(style.marginRight);
		return width;
	};

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Thumbs = exports.Carousel = undefined;
	
	var _Carousel = __webpack_require__(463);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _Thumbs = __webpack_require__(200);
	
	var _Thumbs2 = _interopRequireDefault(_Thumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Carousel = _Carousel2.default;
	exports.Thumbs = _Thumbs2.default;

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(50));
	var shallowEqual = _interopDefault(__webpack_require__(61));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 395:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsiveCarousel = __webpack_require__(466);
	
	var _shush = __webpack_require__(506);
	
	var _shush2 = _interopRequireDefault(_shush);
	
	var _valuerocker = __webpack_require__(508);
	
	var _valuerocker2 = _interopRequireDefault(_valuerocker);
	
	var _purgapalooza = __webpack_require__(505);
	
	var _purgapalooza2 = _interopRequireDefault(_purgapalooza);
	
	var _ = __webpack_require__(500);
	
	var _2 = _interopRequireDefault(_);
	
	var _opshop = __webpack_require__(504);
	
	var _opshop2 = _interopRequireDefault(_opshop);
	
	var _solidgold = __webpack_require__(507);
	
	var _solidgold2 = _interopRequireDefault(_solidgold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imgUrls = ['https://www.redbubble.com/people/jradvan/works/30499628-please-stop-shush-tapestry?asc=u&p=sticker', 'https://www.redbubble.com/people/jradvan/works/31334044-please-stop-value-rocker-pedal?asc=u&p=t-shirt', 'https://www.redbubble.com/people/jradvan/works/30496558-please-stop-purgapalooza-ii-28-apr-2018?asc=u&p=sticker', 'https://www.redbubble.com/people/jradvan/works/32824781-please-stop-50-50?asc=u&p=sticker', 'https://www.redbubble.com/people/jradvan/works/32931130-op-shop-trivia-2017-gig-sticker?asc=u&p=sticker', 'https://www.redbubble.com/people/jradvan/works/32955590-solid-gold-disco-2018-gig-sticker?asc=u&p=sticker'];
	
	function imgClickHandler(index, element) {
	  window.open(imgUrls[index], '_blank');
	}
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _reactResponsiveCarousel.Carousel,
	    { autoPlay: true, dynamicHeight: true, infiniteLoop: true, interval: 5000, centerMode: true, useKeyboardArrows: true, showStatus: false, onClickItem: imgClickHandler },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _shush2.default })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _valuerocker2.default })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _purgapalooza2.default })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _2.default })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _opshop2.default })
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('img', { src: _solidgold2.default })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(props) {
	    return _react2.default.createElement(
	        'footer',
	        { id: 'footer', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'p',
	            { className: 'copyright' },
	            'Built with \u2665 by Ninja Chimp Studios | Cover photo by Andrea Vine'
	        )
	    );
	};
	
	Footer.propTypes = {
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(props) {
	    return _react2.default.createElement(
	        'header',
	        { id: 'header', style: props.timeout ? { display: 'none' } : {} },
	        _react2.default.createElement(
	            'div',
	            { className: 'content' },
	            _react2.default.createElement(
	                'div',
	                { className: 'inner' },
	                _react2.default.createElement(
	                    'h1',
	                    null,
	                    'PLEASE STOP'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Brisbane\'s Best Value Band'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('gigs');
	                            } },
	                        'Gigs'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('merch');
	                            } },
	                        'Merch'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('about');
	                            } },
	                        'About'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'javascript:;', onClick: function onClick() {
	                                props.onOpenArticle('connect');
	                            } },
	                        'Connect'
	                    )
	                )
	            )
	        )
	    );
	};
	
	Header.propTypes = {
	    onOpenArticle: _react2.default.PropTypes.func,
	    timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(52);
	
	var _Carousel = __webpack_require__(220);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	__webpack_require__(313);
	
	var _gatsbyLink = __webpack_require__(75);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _band = __webpack_require__(501);
	
	var _band2 = _interopRequireDefault(_band);
	
	var _merch = __webpack_require__(503);
	
	var _merch2 = _interopRequireDefault(_merch);
	
	var _band3 = __webpack_require__(502);
	
	var _band4 = _interopRequireDefault(_band3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Main = function (_React$Component) {
	  _inherits(Main, _React$Component);
	
	  function Main() {
	    _classCallCheck(this, Main);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Main.prototype.render = function render() {
	    var _this2 = this;
	
	    var close = _react2.default.createElement("div", { className: "close", onClick: function onClick() {
	        _this2.props.onCloseArticle();
	      } });
	
	    return _react2.default.createElement(
	      "div",
	      { id: "main", style: this.props.timeout ? { display: 'flex' } : { display: 'none' } },
	      _react2.default.createElement(
	        "article",
	        { id: "intro", className: (this.props.article === 'gigs' ? 'active' : '') + " " + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          "h2",
	          { className: "major" },
	          "Gigs"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "image main" },
	          _react2.default.createElement("img", { src: _band2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Most shows are private functions but if you want to crash one, knock yourself out."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "ROCK GOD UPDATE: finally had the cops called on us at Pete's VIP Xmas party. So we have that going for us, which is nice."
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "26 Apr 2019 | Paul's 60th @ the Lord Alfred"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "18 May 2019 | Purgapalooza 2019"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "TBC Aug 2019 | McDowall SS Trivia Night"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "25 Dec 2021 | Wembley Arena (probably)"
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        "article",
	        { id: "work", className: (this.props.article === 'merch' ? 'active' : '') + " " + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          "h2",
	          { className: "major" },
	          "Merch"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "image main" },
	          _react2.default.createElement("img", { src: _merch2.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "James is a Dave Matthews Band tragic and insists on following their lead by producing a sticker/poster for every gig we do. Collect the whole set!"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "All our merch is dropshipped from ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://www.redbubble.com/people/jradvan/collections/882180-please-stop", target: "_blank" },
	            "Redbubble"
	          ),
	          ". Their products are great quality and they ship anywhere. There's clothes, stickers, prints, etc. Tea towels and underpants probably on the roadmap."
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(_Carousel2.default, null)
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Wear some Please Stop merch to a gig and we'll autograph your boobs with a marker pen! To be fair we'll probably do that anyway if you ask. No Colin, not you."
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        "article",
	        { id: "about", className: (this.props.article === 'about' ? 'active' : '') + " " + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          "h2",
	          { className: "major" },
	          "About"
	        ),
	        _react2.default.createElement(
	          "span",
	          { className: "image main" },
	          _react2.default.createElement("img", { src: _band4.default, alt: "" })
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Please Stop formed in 2016 with Nick (drums), Pete (lead guitar), Stu (bass) and James (vocal/rhythm guitar), whose kids are all friends from school and Scouts."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Playing a heady mix of 70s/80s/90s rock with smatterings of blues, punk and aussie classics, we're not afraid to put our own spin on your favourites (such as our Violent Femmes-esque cover of Leonard Cohen/Jeff Buckley's \"Hallelujah\")."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "As legend has it the band was named by our wives, who agonized for some time between \"Please Stop\" and \"Honey The Kids Are Trying To Sleep\"."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Things most frequently shouted at our gigs include \"what? I can't hear you\", chants of \"please stop\" and the heckle \"play something we can dance to\" - the latter usually triggering a \"Blister in the Sun\" powered quadragenarian mosh pit which says it all really."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Widely regarded as being \"loud\" and \"surprisingly ok\", the group is held back from runaway international success only by our relaxed attitude to rehearsal, lack of original material and fear of commitment. Also our backs hurt."
	        ),
	        close
	      ),
	      _react2.default.createElement(
	        "article",
	        { id: "contact", className: (this.props.article === 'connect' ? 'active' : '') + " " + (this.props.articleTimeout ? 'timeout' : ''), style: { display: 'none' } },
	        _react2.default.createElement(
	          "h2",
	          { className: "major" },
	          "Connect"
	        ),
	        _react2.default.createElement(
	          "ul",
	          { className: "icons" },
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.facebook.com/pleasestopband", target: "_blank", className: "icon fa-facebook" },
	              _react2.default.createElement(
	                "span",
	                { className: "label" },
	                "Facebook"
	              )
	            ),
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Message or book us on Facie"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "#", className: "icon fa-spotify" },
	              _react2.default.createElement(
	                "span",
	                { className: "label" },
	                "Spotify"
	              )
	            ),
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Original releases (when we have some)"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "https://soundcloud.com/please-stop-band", target: "_blank", className: "icon fa-soundcloud" },
	              _react2.default.createElement(
	                "span",
	                { className: "label" },
	                "Soundcloud"
	              )
	            ),
	            _react2.default.createElement(
	              "h3",
	              null,
	              "Jam tracks and live recordings"
	            )
	          )
	        ),
	        close
	      )
	    );
	  };
	
	  return Main;
	}(_react2.default.Component);
	
	Main.propTypes = {
	  route: _react2.default.PropTypes.object,
	  article: _react2.default.PropTypes.string,
	  articleTimeout: _react2.default.PropTypes.bool,
	  onCloseArticle: _react2.default.PropTypes.func,
	  timeout: _react2.default.PropTypes.bool
	};
	
	exports.default = Main;
	module.exports = exports["default"];

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/5050.07bd4434.jpg";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/band01.ada47901.png";

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/band02.992749c9.png";

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/merch01.50baf523.png";

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opshop17.d51b2fd5.jpg";

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/purgapalooza2.0963c290.jpg";

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shush.e4fc43f9.jpg";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/solidgold.a2ff5f49.jpg";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/valuerocker.4f1fb2f9.jpg";

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(395);
	
	var _reactHelmet = __webpack_require__(57);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(222);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Main = __webpack_require__(223);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Footer = __webpack_require__(221);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template(props) {
	    _classCallCheck(this, Template);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isArticleVisible: false,
	      timeout: false,
	      articleTimeout: false,
	      article: '',
	      loading: 'is-loading'
	    };
	    _this.handleOpenArticle = _this.handleOpenArticle.bind(_this);
	    _this.handleCloseArticle = _this.handleCloseArticle.bind(_this);
	    return _this;
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.timeoutId = setTimeout(function () {
	      _this2.setState({ loading: '' });
	    }, 100);
	  };
	
	  Template.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeoutId) {
	      clearTimeout(this.timeoutId);
	    }
	  };
	
	  Template.prototype.handleOpenArticle = function handleOpenArticle(article) {
	    var _this3 = this;
	
	    this.setState({
	      isArticleVisible: !this.state.isArticleVisible,
	      article: article
	    });
	
	    setTimeout(function () {
	      _this3.setState({
	        timeout: !_this3.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this3.setState({
	        articleTimeout: !_this3.state.articleTimeout
	      });
	    }, 350);
	  };
	
	  Template.prototype.handleCloseArticle = function handleCloseArticle() {
	    var _this4 = this;
	
	    this.setState({
	      articleTimeout: !this.state.articleTimeout
	    });
	
	    setTimeout(function () {
	      _this4.setState({
	        timeout: !_this4.state.timeout
	      });
	    }, 325);
	
	    setTimeout(function () {
	      _this4.setState({
	        isArticleVisible: !_this4.state.isArticleVisible,
	        article: ''
	      });
	    }, 350);
	  };
	
	  Template.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    var siteDescription = this.props.data.site.siteMetadata.description;
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	
	    var rootPath = '/';
	
	    var content = void 0;
	
	    if (location.pathname === rootPath) {
	      content = _react2.default.createElement(
	        'div',
	        { id: 'wrapper' },
	        _react2.default.createElement(_Header2.default, { onOpenArticle: this.handleOpenArticle, timeout: this.state.timeout }),
	        _react2.default.createElement(_Main2.default, {
	          isArticleVisible: this.state.isArticleVisible,
	          timeout: this.state.timeout,
	          articleTimeout: this.state.articleTimeout,
	          article: this.state.article,
	          onCloseArticle: this.handleCloseArticle
	        }),
	        _react2.default.createElement(_Footer2.default, { timeout: this.state.timeout })
	      );
	    } else {
	      content = _react2.default.createElement(
	        'div',
	        { id: 'wrapper', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              maxWidth: '1140px'
	            } },
	          children()
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'body ' + this.state.loading + ' ' + (this.state.isArticleVisible ? 'is-article-visible' : '') },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: siteDescription })
	      ),
	      content,
	      _react2.default.createElement('div', { id: 'bg' })
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-d8b7e02c2690b85e4bda.js